"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cognitoPasswordRequirementsForTranslation = void 0;
var ATLEAST_ONE_LOWER_CASE_REGEX = /(?=.*?[a-z])/;
var ATLEAST_ONE_UPPER_CASE_REGEX = /(?=.*?[A-Z])/;
var ATLEAST_ONE_DIGIT_REGEX = /(?=.*?[0-9])/;
var ATLEAST_ONE_SPECIAL_CHARACTER_REGEX = /(?=.*?[#?!@$%^&*-])/;
var cognitoPasswordRequirementsForTranslation = exports.cognitoPasswordRequirementsForTranslation = function cognitoPasswordRequirementsForTranslation(password) {
  var check = !!password;
  if (check) {
    if (password.length > +process.env.REACT_APP_PASSWORD_MAX_LENGTH) {
      return 'maxChars';
    }
    if (password.length < +process.env.REACT_APP_PASSWORD_MIN_LENGTH) {
      return 'minChars';
    }
    if (process.env.REACT_APP_PASSWORD_LOWER_CASE && !ATLEAST_ONE_LOWER_CASE_REGEX.test(password)) {
      return 'lowercase';
    }
    if (process.env.REACT_APP_PASSWORD_UPPERCASE_CASE && !ATLEAST_ONE_UPPER_CASE_REGEX.test(password)) {
      return 'uppercase';
    }
    if (process.env.REACT_APP_PASSWORD_NUMBERS_CASE && !ATLEAST_ONE_DIGIT_REGEX.test(password)) {
      return 'number';
    }
    if (process.env.REACT_APP_PASSWORD_CHARACTERS_CASE && !ATLEAST_ONE_SPECIAL_CHARACTER_REGEX.test(password)) {
      return 'specialChar';
    }
    return false;
  }
  return true;
};
